"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var directionPath = {
    left: 'M19.3115 12.478L16.7402 10L6.36368 20L16.7402 30L19.3115 27.522L13.3929 21.8182H29.0909C31.0992 21.8182 32.7273 20.1901 32.7273 18.1818H13.3929L19.3115 12.478Z',
    right: 'M20.6885 12.478L23.2598 10L33.6363 20L23.2598 30L20.6885 27.522L26.6071 21.8182H10.9091C8.90078 21.8182 7.27272 20.1901 7.27272 18.1818H26.6071L20.6885 12.478Z',
};
var Arrow = function (_a) {
    var width = _a.width, height = _a.height, fill = _a.fill, direction = _a.direction;
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: directionPath[direction], fill: fill })));
};
Arrow.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
    direction: PropTypes.string,
};
Arrow.defaultProps = {
    width: 40,
    height: 40,
    fill: colors_1.grey5,
    direction: 'right',
};
exports.default = Arrow;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXJyb3cuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaWNvbnMvQXJyb3cudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNkJBQStCO0FBQy9CLHNDQUF3QztBQUV4QyxvQ0FBZ0M7QUFFaEMsSUFBTSxhQUFhLEdBQUc7SUFDcEIsSUFBSSxFQUNGLGlLQUFpSztJQUNuSyxLQUFLLEVBQ0gsaUtBQWlLO0NBQzNKLENBQUM7QUFRWCxJQUFNLEtBQUssR0FBeUIsVUFBQyxFQUFnQztRQUEvQixnQkFBSyxFQUFFLGtCQUFNLEVBQUUsY0FBSSxFQUFFLHdCQUFTO0lBQ2xFLE9BQU8sQ0FDTCw2QkFBSyxLQUFLLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFDLFdBQVcsRUFBQyxJQUFJLEVBQUMsTUFBTTtRQUNoRSw4QkFBTSxRQUFRLEVBQUMsU0FBUyxFQUFDLFFBQVEsRUFBQyxTQUFTLEVBQUMsQ0FBQyxFQUFFLGFBQWEsQ0FBQyxTQUFTLENBQUMsRUFBRSxJQUFJLEVBQUUsSUFBSSxHQUFJLENBQ25GLENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLEtBQUssQ0FBQyxTQUFTLEdBQUc7SUFDaEIsS0FBSyxFQUFFLFNBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBUTtJQUN2RSxNQUFNLEVBQUUsU0FBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxNQUFNLEVBQUUsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFRO0lBQ3hFLElBQUksRUFBRSxTQUFTLENBQUMsTUFBTTtJQUN0QixTQUFTLEVBQUUsU0FBUyxDQUFDLE1BQWE7Q0FDbkMsQ0FBQztBQUVGLEtBQUssQ0FBQyxZQUFZLEdBQUc7SUFDbkIsS0FBSyxFQUFFLEVBQUU7SUFDVCxNQUFNLEVBQUUsRUFBRTtJQUNWLElBQUksRUFBRSxjQUFLO0lBQ1gsU0FBUyxFQUFFLE9BQU87Q0FDbkIsQ0FBQztBQUVGLGtCQUFlLEtBQUssQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/Arrow.js
// module id = 52
// module chunks = 0